import React from 'react';
import { SEO } from '../components/SEO';
export function ImpressumPage() {
  return <>
      <SEO title="Impressum - CRM Kraft | Justus Kraft" description="Impressum und rechtliche Angaben von CRM Kraft - Justus Kraft. Kontaktdaten und Haftungsausschluss gemäß § 5 TMG." keywords="Impressum, CRM Kraft, Justus Kraft, rechtliche Angaben" ogType="website" data-id="element-432" data-mp="1m4gglrhe57me" />
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-433" data-mp="2a1433xxt3a4y">
        <div className="max-w-4xl mx-auto" data-id="element-434" data-mp="29zj6m2rxlh4g">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white" data-id="element-435" data-mp="253km4q9q4j9b">
            Impressum
          </h1>

          <div className="prose prose-invert prose-lg max-w-none" data-id="element-436" data-mp="2jqdutcoqmqsj">
            <section className="mb-8" data-id="element-437" data-mp="2es2kl0uj6e9s">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-438" data-mp="2et49a84gyz9z">
                Adresse
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-439" data-mp="2ssn2zvwja82r">
                CRM Kraft LLC
                <br data-id="element-440" data-mp="2oscw8h0x3dmu" />
                Vertreten durch: Justus Kraft
                <br data-id="element-441" data-mp="1u71quxpbvvne" />
                7901 4th St. N, Ste. 300
                <br data-id="element-442" data-mp="1y7vcfkfasyd4" />
                St. Petersburg, FL 33702
                <br data-id="element-443" data-mp="1y8dg324aiev2" />
                United States of America
              </p>
            </section>

            <section className="mb-8" data-id="element-444" data-mp="235df4t2q2hco">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-445" data-mp="2861a1pu2nic6">
                Kontakt
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-446" data-mp="2d5nqe8575ep7">
                Telefon:{' '}
                <a href="tel:+4915735999071" className="text-[#FF5722] hover:underline" data-id="element-447" data-mp="2h6hfh4udkzjo">
                  +49 157 35999071
                </a>
                <br data-id="element-448" data-mp="2qw9ag06dzuoo" />
                E-Mail:{' '}
                <a href="mailto:justus@crm-kraft.de" className="text-[#FF5722] hover:underline" data-id="element-449" data-mp="2qw10oh5k95hp">
                  justus@crm-kraft.de
                </a>
              </p>
            </section>

            <section className="mb-8" data-id="element-450" data-mp="2b6b9jev2ek9q">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-451" data-mp="2b7covvj45sx9">
                EU-Streitschlichtung
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-452" data-mp="265disdvzohwm">
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#FF5722] hover:underline" data-id="element-453" data-mp="2g4ct00wekllq">
                  https://ec.europa.eu/consumers/odr/
                </a>
                . Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section className="mb-8" data-id="element-454" data-mp="2yub12h07aepd">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-455" data-mp="19gfnmukbuhyx">
                Verbraucherstreitbeilegung/Universalschlichtungsstelle
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-456" data-mp="14kh5vpti7y7h">
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </div>
      </main>
    </>;
}